<template>
    <div>
        <div :class="{ 'animated fadeOut': invisible }" id="preview-stage">
            <swiper
                @slideChange="handleQuestionSlideChange"
                :options="swiperOption"
                class="content w-full"
                ref="questionSwiper"
            >
                <swiper-slide :key="question.id" v-for="(question, index) in questions" class="w-full px-0">
                    <section class="layout layout-scale">
                        <div class="header">
                            <div class="flex">
                                <div class="w-12"></div>
                                <h1 class="flex-1 text-center text-white my-0 pb-2 font-size-22">{{ title }}</h1>
                                <p
                                    class="text-right font-bold text-white my-0 font-size-18 w-12 position-relative text-right"
                                >
                                    <span v-if="!$route.params.track" style="position: absolute; right: 0; top: 0.3rem"
                                        >{{ index + 1 }}/{{ questions.length }}</span
                                    >
                                </p>
                            </div>
                        </div>
                        <div class="content flex items-center">
                            <div class="mx-auto content-container w-full">
                                <div class="flex flex-col justify-center items-center">
                                    <div
                                        v-if="
                                            question.image &&
                                            question.image !== '' &&
                                            question.question_type !== 'video' &&
                                            question.question_type !== 'puzzle' &&
                                            question.question_type !== 'hotspot'
                                        "
                                        :class="{ invisible: hideTitleImage }"
                                        class="flex items-center justify-center border-2 border-style"
                                    >
                                        <div
                                            :style="{ 'background-image': 'url(' + question.image + ')' }"
                                            class="bg-main bg-cover bg-center bg-norepeat w-48 sm:w-64 h-48 sm:h-64 rounded"
                                        ></div>
                                    </div>
                                    <!-- VIDEO -->
                                    <div
                                        v-if="question.question_type == 'video'"
                                        :class="{ invisible: hideTitleImage && question.video_provider != 'youtube' }"
                                        class="video-box h-64 border-3 border-solid border-white rounded-lg"
                                    >
                                        <video-player
                                            v-if="question.question_type == 'video'"
                                            :video-meta="question"
                                            :video-path="question.video"
                                            :time-duration="question.video_time"
                                            ref="prevVideo"
                                            class="w-full h-full"
                                        ></video-player>
                                    </div>
                                    <!-- MUSIC -->
                                    <div
                                        v-if="question.question_type == 'music'"
                                        @click="handleSpotifySong(question.spotify_track)"
                                        class="mx-auto cursor-pointer flex flex-col items-center"
                                    >
                                        <Equaliser class="font-size-30" style="margin-bottom: 1rem" />
                                        <div v-if="$route.params.track" class="text-white mt-2">
                                            Click to play music
                                        </div>
                                    </div>
                                </div>
                                <h2 class="text-white font-size-30 md:font-size-30 mb-0 mt-4 text-center mb-8">
                                    {{ question.title }}
                                </h2>
                                <!-- PUZZLE -->
                                <div
                                    v-if="question.question_type === 'puzzle'"
                                    :ref="`puzzle-container-${index}`"
                                    class="puzzle-container"
                                ></div>
                                <!-- Scramble -->
                                <Scramble
                                    v-if="question.question_type === 'scramble'"
                                    :question="question"
                                    :isPlayAlone="true"
                                    :isShowSubmit="false"
                                />
                                <HotspotAnswer
                                    v-if="question.question_type === 'hotspot'"
                                    :question="question"
                                    :show-correct="true"
                                    :is-interact="false"
                                    style="max-width: 368px; max-height: 368px"
                                />
                                <div class="items-center">
                                    <div
                                        v-if="
                                            question.question_type !== 'puzzle' &&
                                            question.question_type !== 'scramble' &&
                                            question.question_type !== 'hotspot'
                                        "
                                        class="text-center w-full"
                                    >
                                        <div v-if="question.answers_required === 'multiple'" class="text-center">
                                            <span class="text-white font-size-16 inline-block mb-2">{{
                                                $t('preview_correct_count', { answersCount: question.answers_count })
                                            }}</span>
                                        </div>

                                        <div v-if="isAllImageAnswer(question.answers)">
                                            <div class="flex flex-wrap justify-center">
                                                <div
                                                    v-for="(answer, answerIndex) in question.answers"
                                                    :key="answerIndex"
                                                    class="cursor-pointer hover:opacity-50"
                                                >
                                                    <div
                                                        @click="toggleSelected(index, answerIndex)"
                                                        :style="{ 'background-image': 'url(' + answer.image + ')' }"
                                                        :class="{
                                                            'opacity-75':
                                                                typeof previewQuestions[index] !== 'undefined' &&
                                                                previewQuestions[index].indexOf(answerIndex) > -1,
                                                            'fade-answer-box': answer.title != ''
                                                        }"
                                                        class="cursor-pointer bg-image bg-center bg-cover border-style w-32 sm:w-48 h-32 sm:h-48 m-2 flex items-center justify-center"
                                                    >
                                                        <i
                                                            v-if="
                                                                answer.is_correct &&
                                                                question.question_type != 'sorting_list'
                                                            "
                                                            class="absolute fas fa-check-circle text-white font-size-38 text-green"
                                                        ></i>
                                                        <i
                                                            v-if="
                                                                !answer.is_correct &&
                                                                question.question_type != 'sorting_list'
                                                            "
                                                            class="absolute fas fa-times-circle text-white font-size-38 text-red"
                                                        ></i>
                                                        <div
                                                            class="absolute px-4 truncate self-end pb-3 font-size-14 sm:font-size-18 text-white text-center w-32 sm:w-48"
                                                        >
                                                            {{ answer.title }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="!isAllImageAnswer(question.answers)">
                                            <div
                                                v-for="(answer, answerIndex) in question.answers"
                                                :key="answerIndex"
                                                class="max-w-lg mx-auto"
                                            >
                                                <div
                                                    v-if="answer.image"
                                                    @click="toggleSelected(index, answerIndex)"
                                                    class="flex items-center justify-center mt-6 mb-2"
                                                >
                                                    <div
                                                        :style="{ 'background-image': 'url(' + answer.image + ')' }"
                                                        :class="{
                                                            'opacity-75':
                                                                typeof previewQuestions[index] !== 'undefined' &&
                                                                previewQuestions[index].indexOf(answerIndex) > -1
                                                        }"
                                                        class="cursor-pointer bg-image bg-center bg-cover border-style w-32 sm:w-48 h-32 sm:h-48 m-2 flex items-center justify-center"
                                                    >
                                                        <i
                                                            v-if="
                                                                answer.is_correct &&
                                                                question.question_type != 'sorting_list'
                                                            "
                                                            class="fas fa-check-circle text-white font-size-38 text-green"
                                                        ></i>
                                                        <i
                                                            v-if="
                                                                !answer.is_correct &&
                                                                question.question_type != 'sorting_list'
                                                            "
                                                            class="fas fa-times-circle text-white font-size-38 text-red"
                                                        ></i>
                                                    </div>
                                                </div>
                                                <button
                                                    @click="toggleSelected(index, answerIndex)"
                                                    v-if="
                                                        (!answer.image && sanitizeAnswerTitle(answer.title)) ||
                                                        sanitizeAnswerTitle(answer.title)
                                                    "
                                                    :class="{
                                                        'opacity-75':
                                                            typeof previewQuestions[index] !== 'undefined' &&
                                                            previewQuestions[index].indexOf(answerIndex) > -1
                                                    }"
                                                    class="relative btn btn-large btn-block font-bold font-size-22 font-opensans mb-2"
                                                >
                                                    <i
                                                        v-if="
                                                            answer.is_correct &&
                                                            question.question_type != 'sorting_list'
                                                        "
                                                        class="fas fa-check-circle text-white font-size-22 absolute text-green"
                                                        style="left: 3%; top: 50%; transform: translateY(-50%)"
                                                    ></i>
                                                    <i
                                                        v-if="
                                                            !answer.is_correct &&
                                                            question.question_type != 'sorting_list'
                                                        "
                                                        class="fas fa-times-circle text-white font-size-22 absolute text-red"
                                                        style="left: 3%; top: 50%; transform: translateY(-50%)"
                                                    ></i>
                                                    <span>{{ answer.title }}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="footer">
                            <div class="flex justify-between align-items-flex-end md:pb-4">
                                <span>
                                    <button
                                        v-if="!$route.params.track"
                                        @click="handleBackToStart"
                                        class="hidden sm:inline-block btn text-left font-size-18 md:font-size-22 font-bold font-opensans"
                                    >
                                        {{ $t('preview_button_close') }}
                                    </button>
                                    <button
                                        v-if="!$route.params.track"
                                        @click="handleBackToStart"
                                        class="inline-block sm:hidden sm-btn btn text-left font-size-18 md:font-size-22 font-bold font-opensans"
                                    >
                                        <i class="fas fa-times"></i>
                                    </button>
                                </span>
                                <div
                                    v-if="
                                        approvalStatus === 'approved' ||
                                        approvalStatus === 'rejected' ||
                                        approvalStatus === 'pending'
                                    "
                                    :class="{
                                        'text-center message-box w-full max-w-lg mx-auto': true,
                                        'is-rejected': approvalStatus === 'rejected',
                                        'is-pending': approvalStatus === 'pending',
                                        'is-approved': approvalStatus === 'approved'
                                    }"
                                >
                                    <span v-if="approvalStatus === 'pending'">{{ $t('setting_alert_checking') }}</span>
                                    <span v-if="approvalStatus === 'rejected'"
                                        >{{ $t('setting_alert_not_approval')
                                        }}<strong v-if="rejectMessage"><br />"{{ rejectMessage }}"</strong></span
                                    >
                                    <span v-if="approvalStatus === 'approved'"
                                        >{{
                                            $t('preview_alert_approve', {
                                                approvedCountTxt:
                                                    typeof approvedCount !== 'undefined' && approvedCount > 1
                                                        ? ''
                                                        : $t('preview_alert_approve_count_text')
                                            })
                                        }}.<strong v-if="approvalMessage"><br />"{{ approvalMessage }}"</strong
                                        ><br /><small>{{
                                            $t('preview_alert_approve_at', { approvedAt: approvedAt })
                                        }}</small></span
                                    >
                                </div>
                                <span>
                                    <button
                                        v-if="!isFirstQuestion"
                                        @click="handlePreviousPreview"
                                        class="sm-btn btn text-left mr-2 font-size-18 md:font-size-22 font-bold font-opensans"
                                    >
                                        <i class="fas fa-arrow-left"></i>
                                    </button>
                                    <button
                                        v-if="!isEndQuestion"
                                        @click="handleNextPreview"
                                        class="sm-btn btn font-size-18 md:font-size-22 font-bold font-opensans"
                                    >
                                        <i class="fas fa-arrow-right"></i>
                                    </button>
                                </span>
                            </div>
                        </div>
                    </section>
                </swiper-slide>
            </swiper>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { format } from 'date-fns'
import Background from '@/lib/background.js'
import ResizeScale from '@/lib/resize-scale.js'
import UserService from '@/lib/user'
import Equaliser from '@/components/Equaliser.vue'
import VideoPlayer from '@/components/VideoPlayer.vue'
import Scramble from '@/components/Scramble.vue'
import HotspotAnswer from '@/components/HotspotAnswer.vue'
import helper from '@/lib/helper.js'
import Puzzle from '@/lib/puzzle.js'
import gsap from 'gsap'
import setBackgroundQuestion from '@/mixins/set-bg-question.js'

export default {
    components: {
        swiper,
        swiperSlide,
        Equaliser,
        VideoPlayer,
        Scramble,
        HotspotAnswer
    },

    mixins: [setBackgroundQuestion],

    data: function () {
        return {
            isFirstQuestion: true,
            isEndQuestion: false,
            hideNextButton: false,
            invisible: false,
            previewQuestions: [],
            puzzleSize: null,
            swiperOption: {
                threshold: 30,
                allowTouchMove: false
            },
            questionIndex: 0
        }
    },

    mounted: function () {
        if (this.$route.params.track) {
            if (this.questions.length == 1) {
                this.isEndQuestion = true
            }

            this.initPreviewQuestion()

            //from mixins set bg question//
            this.removeBackdrop()
            this.removeVideoBackdrop()

            if (this.isSupportBasicFullscreen(this.questions[0])) {
                this.setTitleImageToBackground(this.questions[0])
            }

            if (this.isSupportVideoFullscreen(this.questions[0])) {
                this.setVideoToBackground(this.questions[0])
            }

            setTimeout(() => {
                this.resizeScaleQuizFrame()
            }, 100)
        }

        const userService = new UserService()

        if (!this.$route.params.track) {
            userService
                .validateToken()
                .then(() => {
                    let query = this.$route.query
                    this.$store.commit('setIsPreviewMode', query && query.mode === 'preview')
                    this.$store.dispatch('fetchQuestionById', this.$route.params.id).then(() => {
                        if (this.questions.length == 1) {
                            this.isEndQuestion = true
                        }

                        new Background({
                            color: this.backgroundColor,
                            image: this.backgroundImage,
                            type: this.backgroundType,
                            navText: this.frontPageSetting.nav_text
                        })

                        this.initPreviewQuestion()

                        setTimeout(() => {
                            this.resizeScaleQuizFrame()
                        }, 100)

                        //from mixins set bg question//
                        this.removeBackdrop()
                        this.removeVideoBackdrop()

                        if (this.isSupportBasicFullscreen(this.questions[0])) {
                            this.setTitleImageToBackground(this.questions[0])
                        }

                        if (this.isSupportVideoFullscreen(this.questions[0])) {
                            this.setVideoToBackground(this.questions[0])
                        }
                    })
                })
                .catch(() => {
                    window.location.href = '/'
                })
        }
    },

    beforeRouteLeave(to, from, next) {
        this.clearSong()
        next()
    },

    methods: {
        initPreviewQuestion() {
            // Init puzzle for first question
            if (this.questions[0].question_type === 'puzzle') {
                this.setPuzzleImage(this.questions[0], 0)
            }

            if (this.questions[0].question_type === 'music') {
                this.addSong(this.questions[0].spotify_track)
            }

            this.checkTypeOfQuestion(this.questions[0])
        },

        checkTypeOfQuestion(question) {
            switch (question.question_type) {
                case 'reveal_image':
                    this.playRevealImage()
                    break

                case 'scale_image':
                    this.playScaleImage()
                    break
            }
        },

        setPuzzleImage(question, index) {
            let layoutElem = document.getElementsByClassName('layout')[index]
            let horizontalPieces = Math.floor(Math.sqrt(question.puzzle_block))
            let verticalPieces = Math.ceil(Math.sqrt(question.puzzle_block))
            let pieces = {
                horizontalPieces,
                verticalPieces
            }

            if (!question.puzzle_block) {
                pieces = {
                    horizontalPieces: 2,
                    verticalPieces: 2
                }
            }

            if (!this.$refs[`puzzle-container-${index}`]) {
                return
            }

            this.puzzleSize = 500

            if (layoutElem.getBoundingClientRect().width < 1366) {
                this.puzzleSize =
                    layoutElem.getBoundingClientRect().width > 400 ? 400 : layoutElem.getBoundingClientRect().width
            }

            this.$refs[`puzzle-container-${index}`][0].style.width = `calc(${this.puzzleSize}px - 2rem)`
            this.$refs[`puzzle-container-${index}`][0].style.height = `calc(${this.puzzleSize}px - 2rem)`

            new Puzzle(
                {
                    container: this.$refs[`puzzle-container-${index}`][0],
                    image: question.image,
                    stageId: `puzzle-question-${index}`,
                    onComplete: () => {}
                },
                pieces
            )
        },

        playScaleImage() {
            gsap.fromTo(
                '.bg-main',
                { backgroundSize: '500% 500%', filter: 'blur(0px)' },
                { backgroundSize: '100% 100%', filter: 'blur(0px)', duration: 10, ease: 'none' }
            )
        },

        playRevealImage() {
            gsap.fromTo(
                '.bg-main',
                { filter: 'blur(10px)', backgroundSize: '100% 100%' },
                { filter: 'blur(0px)', backgroundSize: '100% 100%', duration: 10, ease: 'none' }
            )
        },

        handleBackToStart: function () {
            //from mixins set bg question//
            this.removeBackdrop()
            this.removeVideoBackdrop()

            this.$store.commit('toggleMainLoader', true)
            this.invisible = true

            setTimeout(
                function () {
                    window.history.back()
                    this.$store.commit('toggleMainLoader', false)
                }.bind(this),
                500
            )
        },

        isAllImageAnswer: function (answers) {
            var hasImages = 0

            answers.forEach(function (answer) {
                if (answer.image !== null && answer.image !== '' && typeof answer.image !== 'undefined') {
                    hasImages++
                }
            })

            return hasImages == answers.length
        },

        handlePreviousPreview: function () {
            this.swiper.slidePrev()
        },

        handleNextPreview: function () {
            this.swiper.slideNext()
        },

        handleQuestionSlideChange: function () {
            this.clearSong()
            if (this.$refs.prevVideo) {
                this.$refs.prevVideo.forEach(el => {
                    if (el.videoMeta.uid == this.questions[this.questionIndex].uid) {
                        el.stopVideo()
                    }
                })
            }

            this.isFirstQuestion = this.swiper.isBeginning
            this.isEndQuestion = this.swiper.isEnd
            this.questionIndex = this.swiper.activeIndex

            const question = this.questions[this.questionIndex]

            if (question.question_type == 'puzzle') {
                this.setPuzzleImage(question, this.questionIndex)
            }

            if (question.question_type === 'music') {
                this.addSong(question.spotify_track)
            }

            this.checkTypeOfQuestion(this.questions[this.questionIndex])
            this.resizeScaleQuizFrame()

            //from mixins set bg question//
            this.removeBackdrop()
            this.removeVideoBackdrop()

            if (this.isSupportBasicFullscreen(question)) {
                this.setTitleImageToBackground(question)
            }

            if (this.isSupportVideoFullscreen(question)) {
                this.setVideoToBackground(question)
            }
        },

        handleSpotifySong() {
            if (this.audioSpotify.paused) {
                this.audioSpotify.play()
            } else {
                this.audioSpotify.pause()
            }
        },

        addSong(track) {
            let audio = this.audioSpotify

            let cachePreviewUrl = track.cache_preview_url ? track.cache_preview_url : track.preview_url

            cachePreviewUrl = cachePreviewUrl.indexOf('mp3') > -1 ? cachePreviewUrl : `${cachePreviewUrl}.mp3`

            this.songXhrRequest = helper.ajaxBlob(
                cachePreviewUrl,
                res => {
                    audio.setAttribute('src', res)
                    if (!this.$route.params.track) {
                        this.playSong()
                    }
                    audio.setAttribute('data-spotify-id', track.id)
                },
                () => {}
            )
        },

        playSong() {
            let audio = this.audioSpotify
            audio.play()
            audio.muted = false
        },

        clearSong() {
            this.audioSpotify.setAttribute('src', null)
            this.audioSpotify.removeAttribute('data-spotify-id')
        },

        sanitizeAnswerTitle: function (title) {
            title = title.replace(/^\s+|\s+$/g, '')

            return !title.length ? false : title
        },

        toggleSelected(questionIndex, answerIndex) {
            let newSelected = []
            let isMultiple = false
            let isCanPush = false
            let hasRemove = false
            let answersCount = 0

            this.questions.forEach((question, index) => {
                if (typeof this.previewQuestions[index] === 'undefined') {
                    newSelected[index] = []
                } else {
                    newSelected[index] = this.previewQuestions[index]
                }

                if (questionIndex === index) {
                    isMultiple = question.answers_required === 'multiple'

                    if (isMultiple) {
                        answersCount = question.answers_count
                    }
                }
            })

            newSelected[questionIndex].forEach(answer => {
                if (answer === answerIndex) {
                    newSelected[questionIndex] = this.removeArrayByValue(newSelected[questionIndex], answerIndex)
                    isCanPush = false
                    hasRemove = true
                } else {
                    isCanPush = isMultiple ? true : false
                }
            })

            if (!hasRemove && newSelected[questionIndex].length === 0) {
                newSelected[questionIndex] = [answerIndex]
            }

            if (isCanPush && newSelected[questionIndex].length < answersCount) {
                newSelected[questionIndex].push(answerIndex)
            }

            this.previewQuestions = newSelected
        },

        removeArrayByValue(arr) {
            var what,
                a = arguments,
                L = a.length,
                ax
            while (L > 1 && arr.length) {
                what = a[--L]
                while ((ax = arr.indexOf(what)) !== -1) {
                    arr.splice(ax, 1)
                }
            }
            return arr
        },

        resizeScaleQuizFrame() {
            const index = this.questionIndex
            const contents = document.getElementsByClassName('content-container')
            const contentElem = contents[index]
            const layoutElem = document.getElementsByClassName('layout')[index]
            const headerElem = document.getElementsByClassName('header')[index]
            const footerElem = document.getElementsByClassName('footer')[index]
            const footerHeight = footerElem.getBoundingClientRect().height
            const headerHeight = headerElem.getBoundingClientRect().height
            const uselessHeight = headerHeight + footerHeight

            for (let x in contents) {
                if (typeof contents[x] === 'object') {
                    contents[x].style.transform = 'none'
                }
            }

            layoutElem.style.setProperty('--useless-h', `${uselessHeight}px`)

            new ResizeScale({
                width: contentElem.getBoundingClientRect().width,
                height: contentElem.getBoundingClientRect().height,
                child: contentElem,
                parent: layoutElem,
                uselessHeight: uselessHeight,
                noTransForm: true
            })

            document.getElementById('app').classList.add('overflow-hidden')
            document.getElementById('app').classList.add('relative')
        }
    },

    computed: {
        ...mapGetters({
            audioSpotify: 'getSpotifyAudio'
        }),

        ...mapState({
            title: state => state.question.title,
            questions: state => state.question.questions,
            backgroundType: state => state.question.background_type,
            backgroundColor: state => state.question.background_color,
            backgroundImage: state => state.question.background_image,
            approvalStatus: state => state.question.approval_status,
            rejectMessage: state => state.question.reject_message,
            approvalMessage: state => state.question.approval_message,
            approvedAt: state => {
                if (!state.question.approved_at) {
                    return ''
                }

                let date = new Date(parseFloat(state.question.approved_at.$date.$numberLong))

                return format(date, 'dd-MM-yy HH:mm')
            },
            approvedCount: state => state.question.approved_count,
            number_approved: state => state.question.number_approved,
            swiper() {
                return this.$refs.questionSwiper.swiper
            },
            frontPageSetting: state => state.frontPageSetting
        })
    }
}
</script>

<style lang="scss" scoped>
.layout {
    height: calc(100vh - 2rem);
    height: calc((var(--vh, 1vh) * 100) - 2rem);
}

@media screen and (max-width: 575px) {
    .sm-btn {
        padding: 0;
        width: 40px;
        height: 40px;
        border-radius: 50%;
    }
}

@media screen and (min-width: 768px) and (max-width: 1920px) {
    section.layout .content {
        overflow: hidden;
        height: calc(100% - var(--useless-h));
    }
}

@media screen and (min-width: 768px) {
    section.layout .content {
        // overflow-y: inherit;
        // overflow-x: inherit;
    }
}

@media screen and (max-width: 767px) {
    section.layout .content {
        overflow: hidden;
        height: calc(100% - var(--useless-h));
    }
    section.layout .footer {
        bottom: 0;
        padding-bottom: 0;
    }
    .content-container.poll {
        overflow-y: auto;
    }
}

.video-box {
    min-width: 450px;
    max-width: 450px;
}

@media screen and (max-width: 500px) {
    .video-box {
        min-width: calc(91vw);
        height: auto;
    }
}

/* Adjust scale over HD */
@media (min-width: 1950px) {
    .footer {
        margin-top: calc(-2vw + -2vh);
    }
}

.fade-answer-box:before {
    content: '';
    border-radius: 0.45rem;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-end;
    text-align: center;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0) 70%);
}
</style>
